<template>
  <div class="popup-wrapper">
    <div v-if="!mobile" class="popup-desktop">
      <b-modal
          id="social-popup-modal"
          v-model="visible"
          centered
          dialog-class="popup-desktop"
          hide-footer
          hide-header
          no-close-on-backdrop
          no-fade
      >
        <div class="position-relative h-100">
          <div v-if="!noCloseButton" class="close-popup">
            <div class="close-icon">
              <b-icon font-scale="3" icon="x" @click="closePopup"></b-icon>
            </div>
          </div>
          <div class="popup-outer-container">
            <div class="popup-middle-container">
              <div class="popup-inner-container">
                <slot></slot>
              </div>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
    <div v-else class="popup-mobile">
      <b-modal
          id="social-popup-modal"
          v-model="visible"
          dialog-class="popup-mobile"
          hide-footer
          hide-header
      >
        <div :style="cssVars" class="popup-outer-container">
          <div class="popup-middle-container">
            <div class="popup-inner-container">
              <slot></slot>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      visible: false
    }
  },
  props: {
    mobile: {
      type: Boolean, default: false
    },
    mobilePopupHeight: {
      type: String, default: 'auto'
    },
    noCloseButton: {
      type: Boolean, default: false
    }
  },
  computed: {
    cssVars() {
      return {
        '--mobile-popup-height': this.mobilePopupHeight
      }
    }
  },
  methods: {
    showModal() {
      this.visible = true;
    },
    hideModal() {
      this.visible = false;
    },
    closePopup() {
      this.hideModal();
      this.$emit("closePopup");
    }
  },
  mounted() {
    this.showModal();
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/style/_social.scss";

::v-deep .popup-desktop {
  &.modal-dialog, .modal-content, .modal-body {
    position: relative;
    height: 100%;
    padding: 0;
    margin: 0;
    background-color: $popup-background-color;
    border: none;
    border-radius: 0;
    max-width: 100% !important;
  }

  .popup-outer-container {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;

    .popup-middle-container {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      max-width: 100%;
      max-height: 100%;
      overflow: auto;
    }

    .popup-inner-container {
      padding: $dim-5x $dim-8x;
      //width: 100%;
      //height: 100%;
      max-width: 100%;
      max-height: 100%;
      position: relative;
      margin: auto;
      flex-grow: 1;
    }
  }

  .close-popup {
    position: absolute;
    top: 0;
    right: 0;
    z-index: $social-popup-modal-z-index + 3;

    .close-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: $spacing-1x;
      cursor: pointer;
    }
  }
}

::v-deep .popup-mobile {
  &.modal-dialog, .modal-content, .modal-body {
    position: relative;
    height: 100%;
    padding: 0;
    margin: 0;
    background-color: $popup-background-color;
    border: none;
    border-radius: 0;
    transition: none;
  }

  .popup-outer-container {
    position: absolute;
    bottom: 0;
    display: flex;
    justify-content: center;
    width: 100%;
    height: var(--mobile-popup-height);
    max-width: 100%;
    max-height: 100%;
    overflow: hidden;

    .popup-middle-container {
      position: relative;
      width: 100%;
      //height: 100%;
      overflow: auto;
    }

    .popup-inner-container {
      padding: 0;
      //width: 100%;
      //height: 100%;
      height: var(--mobile-popup-height);
      max-width: 100%;
      max-height: 100%;
      position: relative;
      margin: auto;
    }
  }
}
</style>